"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionType = void 0;
/**
 * Action type.
 *
 * @export
 * @enum {number}
 */
var ActionType;
(function (ActionType) {
    ActionType["Quest"] = "quest";
    ActionType["Achievement"] = "achievement";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
